import { useDispatch, useSelector } from 'react-redux';
import style from './UserBurgerMenu.module.css';

import { selectUser } from '../../../../redux/auth/selectors';
import { useNavigate } from 'react-router-dom';
import { Menu } from 'antd';
import { FaPowerOff } from 'react-icons/fa';

import { logOut } from '../../../../redux/auth/operations';
import AgencyUserBurgerMenu from '../AgencyUserBurgerMenu/AgencyUserBurgerMenu';
import FreeUserBurgerMenu from '../FreeUserBurgerMenu/FreeUserBurgerMenu';
import { useWebSocket } from '../../../WebSocketProvider/WebSocketProvider';

const paidUserItems = [
  {
    key: '/man-user/updates',
    label: 'Updates',
  },
  {
    key: '/man-user/live-chat',
    label: 'Live Chat',
  },
  {
    key: 'Account',
    label: 'Account',
    children: [
      {
        key: '/man-user/purchase-coins',
        label: 'Purchase Coins',
      },
      {
        key: '/man-user/profile',
        label: 'Profile',
      },
      {
        key: '/man-user/expenses',
        label: 'Expenses',
      },
      {
        key: '/man-user/statistics',
        label: 'Statistics',
      },
      {
        key: '/man-user/notifications',
        label: 'Notifications',
      },
    ],
  },
  {
    key: 'MailBox',
    label: 'MailBox',
    children: [
      {
        key: '/man-user/letters/new-letter',
        label: 'New Letter',
      },
      {
        key: '/man-user/letters/inbox',
        label: 'Inbox',
      },
      {
        key: '/man-user/letters/outbox',
        label: 'Outbox',
      },
      {
        key: '/man-user/letters/primary',
        label: 'Primary',
      },
      {
        key: '/man-user/letters/spam',
        label: 'Spam',
      },
      {
        key: '/man-user/letters/trash',
        label: 'Trash',
      },
    ],
  },
  {
    key: '/man-user/customer-support',
    label: 'Support',
  },
  {
    key: 'Soulmates',
    label: 'Soulmates',
    children: [
      {
        key: '/man-user/online-soulmates',
        label: 'Online Soulmates',
      },
      {
        key: '/man-user/fans',
        label: 'Fans',
      },
      {
        key: '/man-user/matches',
        label: 'Matches',
      },
      {
        key: '/man-user/search-soulmates',
        label: 'Search',
      },
    ],
  },
  {
    key: 'Gifts',
    label: 'Gifts',
    children: [
      {
        key: '/man-user/gifts-list',
        label: 'Gifts List',
      },
      {
        key: '/man-user/orders',
        label: 'Orders',
      },
      {
        key: '/man-user/delivered',
        label: 'Delivered',
      },
      {
        key: '/man-user/declined',
        label: 'Declined',
      },
      {
        key: '/man-user/undelivered',
        label: 'Undelivered',
      },
    ],
  },
];

const UserBurgerMenu = ({ close }) => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const isPaidUser = user?.typeAccount === 'paidUser';
  const isFreeUser = user?.typeAccount === 'freeUser';
  const { sendData } = useWebSocket();

  const navigate = useNavigate();
  const handleClick = ({ key }) => {
    navigate(key);
    close();
  };

  const handlePurchaseClick = () => {
    navigate('/man-user/purchase-coins');
    close();
  };

  const handleLogOutClick = () => {
    sendData({ id: user._id }, 'removeOnlineUser');
    dispatch(logOut());
    close();
  };

  if (isPaidUser) {
    return (
      <div className={style.menuContainer}>
        <div className={style.balance}>
          <h3>Balance:{user?.balance}</h3>
          <button
            className={style.purchaseButton}
            onClick={handlePurchaseClick}
          >
            Purchase Coins
          </button>
        </div>
        <Menu
          onClick={handleClick}
          className={style.menu}
          defaultSelectedKeys={['1']}
          defaultOpenKeys={['sub1']}
          mode="inline"
          theme="dark"
          items={paidUserItems}
        />
        <button className={style.logoutButton} onClick={handleLogOutClick}>
          <FaPowerOff className={style.logoutIcon} />
          Log Out
        </button>
      </div>
    );
  }

  if (isFreeUser) {
    return (
      <div>
        <FreeUserBurgerMenu close={close} />
      </div>
    );
  }
  return (
    <div>
      <AgencyUserBurgerMenu close={close} />
    </div>
  );
};

export default UserBurgerMenu;
